import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/fixCarlCoxPoster';
import App from './App';
import { AuthProvider } from './context/AuthContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* 👈 Wrap your app here */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
